// Modelo Grupo homogenio de exposicion.
export default class GrupoHomogenioExposicion {
    id=""
    company=""
    companyJob=""
    companyAgency=""
    type=true
    element=""
    group=""
}



// WEBPACK FOOTER //
// ./src/model/GrupoHomogenioExposicion.js